import React, { useContext, useState } from "react";
import cfe from "../../../services/cfe";
import AppContext from "../../../container/context";
import Form from "../../../components/form";
import { useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";

export default function Editar(props) {
  const [instituicaoId] = useState(Number(props.match.params.id));
  const { notification } = useContext(AppContext);
  const [instituicao, setInstituicao] = useState({});
  const [viaCEP, setViaCEP] = useState(false);
  const [carregandoCEP, setCarregandoCEP] = useState(false);
  const [dadosViaCEP, setDadosViaCEP] = useState("");
  const [dadosEndereco, setDadosEndereco] = useState({});

  useEffect(() => {
    carregarInstituicao();
  }, []);

  const carregarInstituicao = () => {
    cfe
      .get("admin/instituicoes/carregar", { id: instituicaoId })
      .then((res) => {
        const endereco = {
          CEP: res.enderecoCEP,
          logradouro: res.enderecoLogradouro,
          numero: res.enderecoNumero,
          complemento: res.enderecoComplemento,
          bairro: res.enderecoBairro,
          municipio: res.enderecoMunicipio,
          UF: res.enderecoUF,
        };

        setDadosEndereco(endereco);
        setInstituicao(res);
      })
      .catch((e) => notification("error", "Erro ao carregar instituição"));
  };

  const salvar = (form) => {
    form.id = instituicaoId;
    cfe
      .post("admin/instituicoes/editar", form)
      .then(() => {
        notification("success", "Dados cadastrais editados com sucesso.");
        carregarInstituicao();
      })
      .catch((err) => {
        console.log(err);
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Razão social inválida");
          case 2:
            return notification("error", "Nome fantasia inválido");
          case 3:
            return notification("error", "CNPJ inválido");
          case 4:
            return notification(
              "error",
              "Já existe instituição com o CNPJ informado"
            );
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fDados = {
    title: "Dados Cadastrais",
    form: {
      nomeFantasia: {
        label: "Nome fantasia",
        type: "text",
        required: true,
        space: 6,
        value: instituicao.nomeFantasia,
      },
      razaoSocial: {
        label: "Razão social ",
        type: "text",
        required: true,
        space: 6,
        value: instituicao.razaoSocial,
      },
      CNPJ: {
        label: "CNPJ",
        type: "text",
        required: true,
        space: 6,
        value: instituicao.CNPJ,
      },
      inativacao: {
        label: "Inativação",
        type: "date",
        // required: true,
        space: 6,
        value: instituicao.inativacao,
      },
    },

    submit: {
      label: "Salvar",
      action: salvar,
    },
    close: true,
    history: props.history,
  };

  const salvarCobranca = (form) => {
    form.instituicaoId = instituicaoId;
    if (
      form.taxaBoleto < 0 ||
      form.taxaCartao < 0 ||
      form.jurosAtraso < 0 ||
      form.multaAtraso < 0 ||
      form.diaPadraoVencimento < 0 ||
      form.diaPadraoEnvioBoletos < 0
    )
      return notification("warning", "Valor inválido");

    cfe
      .post("admin/instituicoes/salvarParametrosCobrancas", form)
      .then((res) => {
        notification("success", "Dados de cobrança salvo com sucesso");
        carregarInstituicao();
      })
      .catch((err) => {
        console.log(err);
        notification("error", "Dados inválidos");
      });
  };

  const fParams = {
    title: "Parâmetros para cobranças",
    form: {
      emailFinanceiro: {
        label: "Email financeiro",
        type: "text",
        value: instituicao.emailFinanceiro,
        // space: 6,
      },
      taxaBoleto: {
        label: "Taxa para pagamentos via boleto (R$)",
        type: "number",
        value: instituicao.taxaBoleto,
        space: 3,
      },
      taxaCartao: {
        label: "Taxa para pagamentos via cartão (R$)",
        type: "number",
        value: instituicao.taxaCartao,
        space: 3,
      },

      jurosAtraso: {
        label: "Juros por dia de atraso (%)",
        type: "number",
        value: instituicao.jurosAtraso,
        space: 3,
      },
      multaAtraso: {
        label: "Multa por atraso (%)",
        type: "number",
        value: instituicao.multaAtraso,
        space: 3,
      },
      diaPadraoVencimento: {
        label: "Dia padrão para vencimentos",
        type: "number",
        value: instituicao.diaPadraoVencimento,
        // space: 3,
      },
      diaPadraoEnvioBoletos: {
        label: "Dia padrão para envio dos boletos",
        type: "number",
        value: instituicao.diaPadraoEnvioBoletos,
        // space: 3,
      },
    },
    submit: {
      label: "Salvar",
      action: salvarCobranca,
    },
  };

  const salvarEndereco = (form) => {
    form.instituicaoId = instituicaoId;
    form.CEP = form.CEP.replace("-", "");

    cfe
      .post("admin/instituicoes/salvarEndereco", form)
      .then((res) => {
        notification("success", "Endereço salvo com sucesso");
        carregarInstituicao();
      })
      .catch((err) => {
        console.log(err);
        notification("error", "Dados inválidos");
      });
  };

  const fEndereco = {
    title: "Endereço",
    form: {
      CEP: {
        label: "CEP",
        type: "text",
        value: dadosEndereco.CEP,
        required: true,
        space: 4,
      },
      logradouro: {
        label: "Logradouro",
        value: dadosEndereco.logradouro,
        type: "text",
        space: 8,
      },
      numero: {
        label: "Número",
        type: "number",
        value: dadosEndereco.numero,
        required: true,
        space: 4,
      },
      complemento: {
        label: "Complemento",
        value: dadosEndereco.complemento,
        type: "text",
        space: 8,
      },
      bairro: {
        label: "Bairro",
        type: "text",
        value: dadosEndereco.bairro,
        required: true,
        space: 4,
      },
      municipio: {
        label: "Município",
        value: dadosEndereco.municipio,
        type: "text",
        space: 6,
      },
      UF: {
        label: "UF",
        value: dadosEndereco.UF,
        type: "text",
        space: 2,
      },
    },
    submit: {
      label: "Salvar",
      action: salvarEndereco,
    },
    customActions: [
      {
        label: "Preencher via CEP",
        action: () => setViaCEP(true),
      },
    ],
  };

  const buscarViaCEP = (form) => {
    setDadosViaCEP(form.CEP);
    setCarregandoCEP(true);
    if (form.CEP.length !== 8)
      return notification(
        "warning",
        "CEP inválido. Verifique o dado e tente novamente."
      );

    fetch(`https://viacep.com.br/ws/${form.CEP}/json/`)
      .then((response) => response.json())
      .then((dadosCEP) => {
        setCarregandoCEP(false);

        if (dadosCEP.erro)
          return notification(
            "error",
            "CEP inválido. Verifique o dado e tente novamente."
          );
        const endereco = {
          CEP: dadosCEP.cep,
          logradouro: dadosCEP.logradouro,
          numero: "",
          complemento: "",
          bairro: dadosCEP.bairro,
          municipio: dadosCEP.localidade,
          UF: dadosCEP.uf,
        };

        setDadosEndereco(endereco);
        setViaCEP(false);
      })
      .catch((error) => {
        console.error(error);
        setCarregandoCEP(false);
        return notification("warning", "Erro ao buscar CEP");
      });
  };

  const fCEP = {
    title: "Endereço",
    form: {
      CEP: {
        label: "CEP (apenas números)",
        type: "text",
        value: dadosViaCEP,
        required: true,
        // space: 4,
      },
    },
    submit: {
      label: "carregar",
      action: buscarViaCEP,
    },
    close: {
      label: "Fechar",
      action: () => {
        setViaCEP(false);
      },
    },
  };

  return (
    <>
      {!instituicao.id ? (
        <CircularProgress />
      ) : (
        <>
          <Form formData={fDados} />
          <Form formData={fParams} />
          {carregandoCEP ? (
            <Box style={{ textAlign: "center" }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              {viaCEP ? (
                <Form formData={fCEP} />
              ) : (
                <Form formData={fEndereco} />
              )}
            </>
          )}
        </>
      )}
    </>
  );
}
